export default {
  name: 'loading'
};